import { Fade, Skeleton } from "@mui/material";

import PropTypes from "prop-types";

export default function MySkeleton(props) {
  const variant = props.variant || "text";
  const width = props.width || "100%";
  const height = props.height || "30px";
  const show = props.show || true;
  const animation = props.animation || "wave";
  return (
    <Fade in={show} timeout={Math.floor(Math.random() * 1000)} unmountOnExit>
      <Skeleton
        animation={animation}
        variant={variant}
        width={width}
        height={height}
        sx={{ padding: 0, margin: 0 }}>
        {props.children}
      </Skeleton>
    </Fade>
  );
}

MySkeleton.propTypes = {
  variant: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  show: PropTypes.bool,
  animation: PropTypes.string,
  children: PropTypes.node,
};
